import { CriterioSerigy } from "./criterio-serigy";
import { ModelSagresDatatable } from "@/types/model-sagres-datatable";

export class RespostaSerigy extends ModelSagresDatatable {
    avaliacaoId: number
    dimensaoCd: number
    dimensaoDs: string
    criterios: CriterioSerigy[]

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.avaliacaoId) this.avaliacaoId = obj.avaliacaoId
            if (obj.dimensaoCd) this.dimensaoCd = obj.dimensaoCd
            if (obj.dimensaoDs) this.dimensaoDs = obj.dimensaoDs
            if (obj.criterios) this.criterios = obj.criterios.map(c => new CriterioSerigy(c))
        }
    }
}


